import styled from 'styled-components';

import {
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

const Dropdown = styled(SemanticDropdown)`
  &.ui.selection.dropdown {
    border-color: #DEDEDF;
    border-radius: 4px;
    font-size: 14px;
    height: 38px;
  }
  &.ui.visible.selection.dropdown {
    border-color: #DEDEDF;
    border-radius: 4px;
    font-size: 14px;
    height: 38px;
    .menu {
      border-color: #DEDEDF;
    }
  }
`;

export {
  Dropdown,
};
